import React from "react";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import { Typography } from "@mui/material";

export const Loader = ({
  message = "Please wait while fetching data...",
  height = null,
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: height ?? "100vh",
      }}
    >
      <Typography sx={{ fontWeight: "bold" }}>
        {message ?? "Please wait while fetching data..."}
      </Typography>
      <CircularProgress sx={{ mt: 1 }} size={26} />
    </Box>
  );
};
